module.exports = __webpack_public_path__ + "img/48CH_CT.e0eb09a5.png";